<template>
  <div>
    <steps direction="vertical" :active="activeIndex" active-color="#439BFF">
      <step v-for="(item, i) in list" :key="i">
        <van-row v-if="cancelState[item.invitation_apply_id] === undefined">
          <van-col span="18" @click="companyDetailFn(item)">
            <h3>{{item.interview_time_str}}</h3>
            <p>{{item.company_name}} | {{item.job_name}}</p>
            <!-- <p v-if="item.invitation_index">面试序号{{item.invitation_index}}</p> -->
            <p
              v-if="parseInt(item.interview_result) > 0"
            >面试结果: {{interview_result[parseInt(item.interview_result)]}}</p>
          </van-col>
          <van-col
            span="6"
            :class="'tr ' + (parseInt(item.interview_state) < 2 ? ' can-cancel':' no-cancel')"
          >
            <van-button
              size="small"
              type="info"
              plain
              @click="dealFn(item)"
            >{{faceState[item.interview_state]}}</van-button>
          </van-col>
        </van-row>
      </step>
    </steps>
  </div>
</template>

<script>
import { Step, Steps } from "vant";
import { mapState } from "vuex";

export default {
  name: "invitation",
  components: {
    Step,
    Steps
  },
  computed: {
    ...mapState({
      route: state => state.route,
      sign: state => state.sign,
      myApplyObj: state => state.myApplyObj,
      user_name: state => state.user_name,
      faceState: state => state.faceState
    })
  },
  props: {
    list: {
      type: Array
    },
    jobfair: {
      type: Object
    }
  },
  data() {
    return {
      activeIndex: 0,
      cancelState: {},
      interview_result: {
        0: "",
        1: "合适",
        2: "不合适"
      }
    };
  },
  mounted() {
    this.initActive();
  },
  methods: {
    initActive() {
      let that = this;
      const { list } = that;

      let activeIndex = list.length;

      const { current_status } = this.jobfair || {};

      if (current_status !== "已结束") {
        let item;
        for (let index = 0; index < list.length; index++) {
          item = list[index];
          if (parseInt(item.interview_state) < 2) {
            activeIndex = index;
            break;
          }
        }
      }

      that.activeIndex = activeIndex;
    },
    finishAlert() {
      this.$dialog
        .alert({
          title: "已结束",
          message: "该场双选会已结束!"
        })
        .then(() => {});
    },
    dealFn(item) {
      const { current_status } = this.jobfair || {};
      const { interview_state, company_name } = item;

      if (current_status === "已结束") {
        this.finishAlert();
        return;
      }

      if (parseInt(interview_state) === 0) {
        this.$dialog
          .confirm({
            title: "取消排队",
            message: "确定取消" + (company_name || "") + "公司的排队?"
          })
          .then(() => {
            this.cancelInvitation(item);
          })
          .catch(() => {
            // on cancel
          });
      }
    },
    cancelInvitation(item) {
      const { invitation_apply_id, video_erp_register_id, video_jobfair_id } = item;

      let that = this;

      const { sign } = this;

      const params = {
        invitation_apply_id,
        sign
      };

      that.$toast.loading({
        duration: 0,
        message: "加载中...",
        forbidClick: true
      });

      return new Promise(resolve => {
        that.$util
          .get("kzp_video_jobfair", "cancel_stu_invitation", params)
          .then(res => {
            const { msg, code } = res;

            that.$toast.clear();

            if (code === 1) {
              that.cancelState[invitation_apply_id] = item;

              that.$store.commit("update_single_state", {
                key: "websocket_send_data",
                data: {
                  flag: "notice",
                  msg_from: "user",
                  receiver_uid: video_erp_register_id,
                  business_type: "取消",
                  business_txt: (that.user_name || "") + "取消了面试排队",
                  business_id: invitation_apply_id,
                  group_id: video_jobfair_id
                }
              });

              // 刷新列表
              that.$emit("refresh", {});
            } else {
              // 提示错误
              that.$notify({
                message: msg || "操作失败,请稍后再试!",
                type: "danger"
              });
            }
            resolve(res);
          });
      });
    },
    toInterview(item) {
      const { invitation_apply_id } = item;

      const { current_status } = this.jobfair || {};

      if (current_status === "已结束") {
        this.finishAlert();
        return;
      }

      // 状态为  面试中:1, 待面试: 0
      let interview_state = parseInt(item.interview_state);
      if (interview_state < 2) {
        this.$router.push({
          path: "/interview?invitation_apply_id=" + invitation_apply_id
        });
      }
    },
    companyDetailFn(item) {
      const { company_id, video_erp_register_id, video_jobfair_id } = item;

      this.$router.push({
        path:
          "/sub/company-detail?company_id=" +
          company_id +
          "&video_erp_register_id=" +
          video_erp_register_id +
          "&video_jobfair_id=" +
          video_jobfair_id
      });
    }
  },
  watch: {
    list: {
      handler(val, oldVal) {
        if (val > oldVal) {
          this.initActive();
        }
      },
      deep: true
    }
  }
};
</script>

<style lang="scss">
</style>
